import { defineElement, BaseElement } from '@webtides/element-js';
import '../arrow-box/arrow-box.js';

class ArrowBoxTrigger extends BaseElement {
    properties() {
        return {
            label: '',
            arrow: 'down',
            arrowClass: '',
        };
    }

    connectedCallback() {
        if (this.getAttribute('label') !== 'undefined' || this.label) {
            super.connectedCallback();
        }
    }

    watch() {
        return {
            label: (newLabel, _) => (this.$arrowBox.innerHTML = newLabel),
        };
    }

    connected() {
        this.$arrowBox = document.createElement(`arrow-box`);
        this.$arrowBox.arrow = this.arrow;
        this.$arrowBox.innerHTML = this.label;
        this.$arrowBox.classList.add('arrow-box-animated', ...this.arrowClass.split(' '));
        this.$arrowBox.style.position = 'fixed';
    }
    disconnected() {
        if (this.$arrowBox) {
            this.$arrowBox.remove();
        }
    }

    updatePosition() {
        let { top, left } = this.getBoundingClientRect();
        //center by default
        this.$arrowBox.style.top = `${top - this.clientHeight * 0.5}px`;
        this.$arrowBox.style.left = `${left + this.clientWidth * 0.5}px`;
    }

    events() {
        return {
            this: {
                mouseenter: () => {
                    this.updatePosition();
                    document.body.append(this.$arrowBox);
                    requestAnimationFrame(() => {
                        this.$arrowBox.classList.add('play-animation');
                    });
                },
                mouseleave: e => {
                    this.$arrowBox.remove();
                    this.$arrowBox.classList.remove('play-animation');
                },
            },
            window: {
                scroll: () => {
                    this.$arrowBox.remove();
                    this.$arrowBox.classList.remove('play-animation');
                },
            },
        };
    }
}

defineElement('arrow-box-trigger', ArrowBoxTrigger);
